import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Ĉiuj scias tiujn longajn molajn rubandojn da tempo, kiuj estas vendataj en magazenoj. 
        Oni povas aĉeti ilin laŭ la longo kaj fari el ili ĉion, kio eblas kaj kio estas necesa, de manĝaĵo ĝis kosmoŝipoj – depende de la longeco, 
        vasteco kaj dikeco de la rubando. 
        Ja la tempon eblas ĉifi, distiri kaj kuntiri – tion scias ĉiuj, sur tio estas bazita nia civilizacio. 
        El la ŝanĝoj de tempo ni ricevas energion, kiel aliuj ricevas ĝin el la ŝanĝoj de materio aŭ spaco. 
      </p>
      
      <p class="mb-3">
        Sed jen kio okazis foje al iu malgranda knabo. 
      </p>
      
      <p class="mb-3">
        En nia familio estis kelkaj infanoj; la plej aĝa jam finis lernejon, du lernis en mezlernejo, kaj la plej eta, Ѭ, ankoraŭ ne lernis. 
        Ĉiuj tri liaj gepatroj estis okupitaj pri siaj laboroj, kaj la etulo ofte restis hejme sola. 
        Sed kutime li ne tro enuis, ĉar scipovis trovi por si mem ian interesan okupon. 
        Precipe allogis lin kajeroj de liaj pliaĝaj gefratoj. 
        Kaj jen foje li trovis tie la trejnan temposkalon por la 6a lernojaro, kie estis prezentita historio de iu imagita planedo. 
        Necesis simple kontroli la gradaron de tiu skalo – la sperto kutima por lernantoj de 10-umba aĝo. 
        Sed Ѭ atingis nur 4-umban aĝon kaj nenion sciis pri skalogradado. 
        Li simple deŝiris de la subbazo la agrablan por tuŝi molan, glatan, elastan rubandon kaj ekludis per ĝi, ĉifante, 
        distirante kaj volvante ĝin diversmaniere.  
      </p>
      
      <p class="mb-3">
        La Nokto de St. Bartolomeo koincidis ĉe li kun la Nokto de longaj tranĉiloj; pafekzekuto de la rusa caro Nikolao II – 
        kun la pafekzekuto de meksika imperiestro Maksimiliano I (kial en historio oni skribas nur pri militoj kaj murdoj? 
        Tamen ne gravas: tio estis ja imagita planedo kun imagita historio, simple lernotasko!). 
        La historion de kelkaj nordaj kaj sudaj triboj la infano distiris je miljaroj, dum kiuj nenio okazis kaj nenio ŝanĝiĝis. 
        Sed en kelkaj latinamerikaj ŝtatoj li male, distordis la historion per tiom da nodetoj, 
        ke tie ĉiujn kelkjarojn okazadis ŝtatrenversoj, kiuj ree kaj ree revenigis la landon al la sama nivelo. 
      </p>
      
      <p class="mb-3">
        Ni aĉetis por ŝi novan kajeron por praktikaj taskoj, kaj lin punis per senigo de borskumo por 1/20 da umbo. 
        Endas ekde infanaĝo inokuli la estimon al la tempo, en kiu ni loĝas, kiun ni konsumas kaj el kiu konsistas ĉio en nia mondo!
      </p>
      
      <p class="mb-3">
        Tamen, la aĉigitan kajeron ni devis forĵeti. Ne gravas! 
        Ni ja havas multe da tempo! 
        Kaj tio estis nur lerneja tasko pri imagita planedo! 
        Oni elpensis tiun taskon por trejni infanojn, kaj simple forĵetis el la tempo, kiam infano fuŝis ĝin. 
      </p>
      
      <p class="mb-3">
        Kaj Ѭ elkreskis je bona knabo kaj ne plu ludis pri la tempo. 
      </p>


    </div>
    `
  )
}

const itemName = {
  esp: 'Infanaj petolaĵoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;